export const services = [
  {
    id: 'application-development',
    title: 'Application Development',
    shortDesc: 'Custom web and mobile solutions using cutting-edge technologies.',
    description: [
      'Full-stack web application development',
      'Mobile app development (iOS & Android)',
      'Progressive Web Applications (PWA)',
      'Custom software development',
      'UI/UX design and development',
      'API development and integration',
      'Database design and optimization',
      'Cloud-native application development'
    ],
    image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&q=80&w=1000',
    icon: '💻',
    link: '/services/application-development'
  },
  {
    id: 'software-testing',
    title: 'Software Testing',
    shortDesc: 'Comprehensive testing services ensuring quality and reliability.',
    description: [
      'Automated testing solutions',
      'Manual testing services',
      'Performance testing',
      'Security testing',
      'Quality assurance consulting',
      'Test automation framework development',
      'Load and stress testing',
      'Cross-browser compatibility testing'
    ],
    image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&q=80&w=1000',
    icon: '🔍',
    link: '/services/software-testing'
  },
  {
    id: 'it-consulting',
    title: 'IT Consulting',
    shortDesc: 'Strategic technology consulting for digital transformation.',
    description: [
      'Digital transformation strategy',
      'Technology roadmap planning',
      'IT infrastructure optimization',
      'Cloud migration consulting',
      'Enterprise architecture design',
      'Technology stack assessment',
      'Security audit and planning',
      'Process automation consulting'
    ],
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=1000',
    icon: '🎯',
    link: '/services/it-consulting'
  },
  {
    id: 'erp-implementation',
    title: 'ERP Implementation',
    shortDesc: 'End-to-end ERP solutions for streamlined operations.',
    description: [
      'ERP system implementation',
      'Business process optimization',
      'Data migration services',
      'Integration solutions',
      'Post-implementation support',
      'Custom ERP development',
      'Training and documentation',
      'Performance monitoring'
    ],
    image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?auto=format&fit=crop&q=80&w=1000',
    icon: '🔄',
    link: '/services/erp-implementation'
  },
  {
    id: 'digital-marketing',
    title: 'Digital Marketing',
    shortDesc: 'Comprehensive digital marketing services for growth.',
    description: [
      'Search Engine Optimization (SEO)',
      'Social Media Marketing',
      'Content Marketing Strategy',
      'Email Marketing Campaigns',
      'Analytics and Reporting',
      'PPC Campaign Management',
      'Conversion Rate Optimization',
      'Marketing Automation'
    ],
    image: 'https://images.unsplash.com/photo-1533750516457-a7f992034fec?auto=format&fit=crop&q=80&w=1000',
    icon: '📈',
    link: '/services/digital-marketing'
  },
  {
    id: 'cloud-services',
    title: 'Cloud Services',
    shortDesc: 'Scalable cloud solutions for modern businesses.',
    description: [
      'Cloud infrastructure setup',
      'Cloud migration services',
      'DevOps implementation',
      'Serverless architecture',
      'Cloud security solutions',
      'Disaster recovery planning',
      'Performance optimization',
      'Cost optimization'
    ],
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=1000',
    icon: '☁️',
    link: '/services/cloud-services'
  },
  {
    id: 'it-training',
    title: 'IT Training',
    shortDesc: 'Comprehensive IT training services for professional growth.',
    description: [
      'Industry-recognized certification programs',
      'Hands-on practical training',
      'Expert-led instruction',
      'Flexible learning options',
      'Project-based learning',
      'Career guidance and support',
      'Latest technology curriculum',
      'Interactive learning environment'
    ],
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800',
    icon: '🎯',
    link: '/services/it-training'
  }
];

export default services; 